import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@kyruus/modal';
import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import {
  MapsErrorBanner,
  MapsNoResultsBanner
} from '../map-search/components/ErrorBanner';

const ErrorModalContainer = styled.div`
  padding: 0 0 ${fromTheme('spacing_medium')};
  @media (min-width: ${fromTheme('screen_medium')}) {
    padding: 20px 20px 40px;
  }
`;

export default function MapErrorModal({
  errorType = '',
  backToSearchUrl,
  showBackToSearchResultLink,
  messages,
  log,
  maxWidth = 'md',
  open = true,
  hideHeaderCloseButton = true,
  hasNoMlocData = false,
  ...props
}) {
  let modalBody;
  if (errorType === 'NO_RESULTS') {
    modalBody = (
      <MapsNoResultsBanner
        backToSearchUrl={backToSearchUrl}
        showBackToSearchResultLink={showBackToSearchResultLink}
        messages={messages}
        hasNoMlocData={hasNoMlocData}
        log={log}
      />
    );
  } else {
    modalBody = <MapsErrorBanner messages={messages} log={log} />;
  }
  return (
    <Modal
      body={<ErrorModalContainer>{modalBody}</ErrorModalContainer>}
      maxWidth={maxWidth}
      open={open}
      hideHeaderCloseButton={hideHeaderCloseButton}
      {...props}
    />
  );
}

MapErrorModal.propTypes = {
  backToSearchUrl: PropTypes.string.isRequired,
  showBackToSearchResultLink: PropTypes.bool.isRequired,
  messages: PropTypes.object.isRequired,
  log: PropTypes.func.isRequired,
  errorType: PropTypes.string,
  maxWidth: PropTypes.string,
  open: PropTypes.bool,
  hideHeaderCloseButton: PropTypes.bool,
  hasNoMlocData: PropTypes.bool
};
